module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/connect-bg-f6ac08ba4a58205914fdac8a5caa9a5f.png";